import React from 'react'
import PropTypes from 'prop-types';
import upperFirst from 'lodash/upperFirst';
import classnames from 'classnames';
import styled from 'styled-components';

const Credits = styled.div`
  background-color: ${({ bgColor }) => bgColor };
  background-repeat: no-repeat;
  background-position: bottom right;
  background-image: ${({ path }) => `url(${path})` };
  background-size: auto 400px;
  font-family: Alegreya, serif;    
  height: calc(100vh - 100px);
  padding: 10px;
  transition: all 0.5s cubic-bezier(.22,.44,0,1);
  overflow: hidden;
  position: absolute;
  transform: translateY(100vh);
  width: 100vw;
  will-change: transform;

  @media (min-aspect-ratio: 16/12) {
    height: calc(100vh - 100px);
  }

  @media (max-width: 650px) {
    height: calc(100vh - 50px);
  }

  &:first-child {
    transform: translateY(50px);
    //transition: all 2s cubic-bezier(.22,.44,0,1);

    @media (min-width: 650px) {
      transform: translateY(100px);
    }
  }
  
    &.is-active {
    transform: translate3d(0, 50px, 0);

    @media (min-width: 650px) {
      transform: translate3d(0, 100px, 0);
    }
  }

  @media (min-width: 480px) {
    padding: 40px;
  }

  @media (max-width: 500px) {
    background-size: 100%;
  }
`;

const CreditRow = styled.div`
  padding: 10px;
  font-size: 16px;
  vertical-align: top;

  @media (min-width: 480px) {
    font-size: 28px;
  }
`;

const CreditLabel = styled.div`
  color: #555;
  display: inline-block;
  text-align: left;
  vertical-align: top;
  width: 45%;
`;

const CreditValue = styled.div`
  display: inline-block;
  text-align: left;
  width: 55%;
  vertical-align: top;
`;

const Credit = ({ path, fields, totalSlides, bgColor, enabled, currentSlideNumber, title }) => {
  const credits = enabled && fields && fields.length > 0 && fields.map((field) => {
    return (
         <CreditRow key={ field.label } className="credits__row">
           <CreditLabel className="credits__label">{ upperFirst(field.label).replace(/_/g, ' ') }</CreditLabel>
           <CreditValue className="credits__value">{ field.value }</CreditValue>
        </CreditRow>
    )
  });

  const classes = [
    'c-folio__slide',
    'c-folio__slide--credits',
    `slide--${totalSlides}`,
    { 'is-active': currentSlideNumber === totalSlides },
    'up-scroll'
  ];

  return enabled ? (
      <Credits className={ classnames(classes) }
               bgColor={ bgColor } path={ path }>
        <h1>{ title }</h1>
        { credits }
      </Credits>) : null;
};

Credit.propTypes = {
  path: PropTypes.string,
  fields: PropTypes.array,
  totalSlides: PropTypes.number,
  bgColor: PropTypes.string,
  currentSlideNumber: PropTypes.number,
  title: PropTypes.string,
};

export default Credit;



// WEBPACK FOOTER //
// ./src/components/Credits/index.js